import {isNil, isNotNil} from 'ramda';

import {useGetBranchQuery} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {useChangeInterestBranchMutation, useGetInterestV2Query} from '@dms/api/finance';

import {TestIdProps} from 'shared/web';

import {handleApiError} from '../../../utils/handleApiError';
import {BranchChanger} from './BranchChanger';

export interface InterestBranchProps extends TestIdProps {
  recordId: string;
}

export function InterestBranch(props: InterestBranchProps) {
  const {data: interest} = useGetInterestV2Query({id: props.recordId});
  const {data: currentUserInfo} = useGetCurrentUserInfoQuery();

  const [changeBranch] = useChangeInterestBranchMutation();

  const userAccessibleBranch = currentUserInfo?.branches?.find(
    (branch) => branch.id === interest?.branchId
  );

  const {data: branchById} = useGetBranchQuery(
    {branchId: interest?.branchId ?? ''},
    {skip: isNil(interest?.branchId) || isNotNil(userAccessibleBranch)}
  );

  const activeBranch = userAccessibleBranch ?? branchById;

  const handleBranchChange = (branchId: string) =>
    changeBranch({
      interestId: props.recordId,
      changeInterestBranchRequestBody: {
        branchId,
      },
    })
      .unwrap()
      .catch(handleApiError);

  return (
    <BranchChanger
      recordId={props.recordId}
      activeBranch={activeBranch}
      onChange={handleBranchChange}
      data-testid={props['data-testid']}
    />
  );
}
